import 'boundless/packages/boundless-popover/build/style.css'
import 'boundless/packages/boundless-dialog/build/style.css'
import './ContextMenu.css';

import React from 'react';
import { MenuItem } from 'react-bootstrap';
import LinkContainer from '../LinkContainer';
import { Popover } from 'boundless';
var NKIcon = require('@norkart/ikoner');

const dropDownStyleOverride = {
    position: 'static',
    top: 'auto',
    left: 'auto',
    zIndex: 'auto',
    display: 'block',
    float: 'none',
    minWidth: 'auto',
    width: 160,
    margin: 0
};

const ContextMenuItem = function ({ to, ...props }) {
    if (to) {
        return <LinkContainer to={to}>
            <MenuItem {...props}>{props.children}</MenuItem>
        </LinkContainer>;
    }
    return <MenuItem {...props}>{props.children}</MenuItem>;
};
const ContextMenuDivider = function (props) {
    return <ContextMenuItem divider {...props}>{props.children}</ContextMenuItem>
};
const ContextMenuHeader = function (props) {
    return <ContextMenuItem header {...props}>{props.children}</ContextMenuItem>
};

class ContextMenuButton extends React.Component {

    state = {
        open: false
    }

    componentDidMount() {
        if (this.props.open !== undefined) {
            this.setState({
                open: this.props.open
            });
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== undefined) {
            this.setState({
                open: nextProps.open
            });
        }
    }

    openContextMenu = (e) => {
        e.stopPropagation();
        this.setState({ open: true })
    }
    closeContextMenu = () => {
        this.setState({ open: false })
    }

    render() {
        let {
            icon,
            iconColor = 'nk-white',
            iconSize = '1',
            label,
            children,
            position = Popover.preset.SSW,
            title
        } = this.props;

        return (
            <button
                className={`btn btn-default btn-xs context-menu-button $className`}
                onClick={this.openContextMenu}
                ref={(ref) => { this.anchor = ref; }}
                title={title}
            >
                {label}
                {this.props.customSize === undefined ? icon && <NKIcon icon={icon} size={iconSize} color={iconColor} /> : icon && <NKIcon icon={icon} height='45' width='24' color={iconColor} />}
                {/*{icon && <NKIcon icon={icon} size={iconSize} color={iconColor} />}*/}
                {this.state.open && <ContextMenu
                    anchor={this.anchor}
                    preset={position}
                    onClose={this.closeContextMenu}>
                    {children}
                </ContextMenu>}
            </button>
        );
    }
}


export const ContextMenu = ({
    children,
    ...props
}) => (<Popover
        {...props}
        autoReposition={true}
        closeOnOutsideFocus={true}
        closeOnEscKey={true}
        className="contextMenu__popover">
        <ul className="dropdown-menu" style={dropDownStyleOverride}>
            {children}
        </ul>
    </Popover>);
ContextMenu.Item = ContextMenuItem;
ContextMenu.Header = ContextMenuHeader;
ContextMenu.Divider = ContextMenuDivider;
ContextMenu.Button = ContextMenuButton;

export default ContextMenu;


// WEBPACK FOOTER //
// ./src/felles/ContextMenu/index.jsx